import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { NavigationPreferences } from "@etain/domain";
import { api } from "./api.js";

export function useNavigationOrder(userId: string, tenantId: string) {
  const queryClient = useQueryClient();
  // Tenant in the cache key prevents in-flight responses crossing a context switch.
  // The persisted preference itself is account-wide.
  const queryKey = ["navigation-order", userId, tenantId];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => api.get<NavigationPreferences>("/auth/profile/navigation", signal),
    enabled: Boolean(userId && tenantId),
    retry: false,
  });
  const save = useMutation({
    mutationFn: (order: NavigationPreferences["order"]) =>
      api.put<NavigationPreferences>("/auth/profile/navigation", { order }),
    onSuccess: async (data) => {
      await queryClient.cancelQueries({ queryKey });
      queryClient.setQueryData(queryKey, data);
    },
  });
  return { query, save, order: query.data?.order ?? [] };
}
